import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserPageTitle } from '@shared/constants/browser-page-title.enum';
import { AuthConnectGuardService } from '../shared';
import { PATHS } from '../shared/constants/paths';
import { InventoryGuardService } from '../shared/services/authentication/inventory-guard.service';
import { InventoryPage } from './inventory.page';
import { InventoryResolverService } from './services/inventory-resolver.service';
import { OfflineGuard } from './route-guards/offline.guard';
import { FoodCostCalculatorResolverService } from './pages/food-cost-calculator/services/food-cost-calculator-resolver.service';

const routes: Routes = [
  {
    path: '',
    component: InventoryPage,
    data: { title: BrowserPageTitle.inventory },
  },
  {
    path: PATHS.ALL_INVENTORY,
    loadChildren: () =>
      import('./pages/all-inventory/all-inventory.module').then(
        m => m.AllInventoryPageModule,
      ),
    canActivate: [AuthConnectGuardService, InventoryGuardService],
  },
  {
    path: PATHS.CREATE_INVENTORY,
    loadChildren: () =>
      import('./pages/create-inventory/create-inventory.module').then(
        m => m.CreateInventoryPageModule,
      ),
    canActivate: [AuthConnectGuardService, InventoryGuardService],
  },
  {
    path: PATHS.INVENTORY_WORKSHEET,
    loadChildren: () =>
      import('./pages/inventory-worksheet/inventory-worksheet.module').then(
        m => m.InventoryWorksheetModule,
      ),
    canActivate: [AuthConnectGuardService, InventoryGuardService],
    canDeactivate: [OfflineGuard],
    resolve: {
      inventory: InventoryResolverService,
    },
  },
  {
    path: PATHS.MANAGE_NON_USF_PRODUCTS,
    loadChildren: () =>
      import(
        './pages/manage-non-usf-products/manage-non-usf-products.module'
      ).then(m => m.ManageNonUsfProductsPageModule),
  },
  {
    path: PATHS.MANAGE_VENDORS,
    loadChildren: () =>
      import('../inventory/pages/manage-vendors/manage-vendors.module').then(
        m => m.ManageVendorsPageModule,
      ),
  },
  {
    path: PATHS.FOOD_COST,
    loadChildren: () =>
      import('./pages/food-cost-calculator/food-cost-calculator.module').then(
        m => m.FoodCostCalculatorPageModule,
      ),
    canActivate: [AuthConnectGuardService, InventoryGuardService],
    resolve: {
      inventory: FoodCostCalculatorResolverService,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InventoryPageRoutingModule {}
